// extracted by mini-css-extract-plugin
module.exports = {"full-screen-button":"styles-module__full-screen-button___1jYxV","full-screen-disabled-button":"styles-module__full-screen-disabled-button___n4YcO"};